import React, { ChangeEvent } from 'react';
import styled from 'styled-components';

const StyledInput = styled.input<{ width?: number; height?: number }>`
  padding: 8px;
  border: 1px solid #e39435;
  border-radius: 4px;
  font-size: 14px;
  width: ${props => props.width ? `${props.width}px` : '100%'};
  height: ${props => props.height ? `${props.height}px` : '100%'};

  &.no-spin-buttons {
    -moz-appearance: textfield;
    
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  &:focus {
    outline: none;
    border-color: #d4851f;
    box-shadow: 0 0 0 2px rgba(227, 148, 53, 0.2);
  }
`;

interface InputFieldProps {
  type: string;
  placeholder: string;
  width?: number;
  height?: number;
  value: string | number;
  min?: number;
  max?: number;
  maxLength?: number; // Keep this for validation purposes but don't use it in HTML
  onChange: (value: string | number) => void;
}

const FoodOptionInput: React.FC<InputFieldProps> = ({ 
  type, 
  placeholder, 
  value,
  width,
  height,
  min,
  max, 
  maxLength, // Accept maxLength but don't pass it to HTML input
  onChange 
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    let param = type === "number" ? parseFloat(event.target.value) : event.target.value;
    onChange(param);
  };

  return (
    <StyledInput
      type={type}
      min={type === "number" ? min : undefined}
      max={type === "number" ? max : undefined}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      className={type === "number" ? 'no-spin-buttons' : ''}
      width={width}
      height={height}
    />
  );
};

export default FoodOptionInput;